/**
 * FreigabenButton — Top-Bar-Button "E-Mail-Freigaben" mit Live-Zähler.
 *
 * Robust & eigenständig: lädt selbst die Anzahl offener Freigaben
 * (email_drafts mit status='ready_for_review'), aktualisiert alle 30s und
 * beim Fenster-Fokus. Klick führt zu /kommunikation/entwuerfe.
 *
 * Bewusst ohne externe Hooks/Props gebaut, damit der Button nicht versehentlich
 * wieder aus der Leiste verschwindet.
 */

import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'wouter';
import { Mail } from 'lucide-react';
import { supabase } from '@/lib/supabase';

export default function FreigabenButton() {
  const [, setLocation] = useLocation();
  const [count, setCount] = useState(0);

  const loadCount = useCallback(async () => {
    const { count: c, error } = await supabase
      .from('email_drafts')
      .select('id', { count: 'exact', head: true })
      .eq('status', 'ready_for_review');
    if (!error && typeof c === 'number') setCount(c);
  }, []);

  useEffect(() => {
    loadCount();
    const iv = setInterval(loadCount, 30000);
    const onFocus = () => loadCount();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(iv);
      window.removeEventListener('focus', onFocus);
    };
  }, [loadCount]);

  return (
    <button
      onClick={() => setLocation('/kommunikation/entwuerfe')}
      className="relative w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
      title={`E-Mail-Freigaben${count > 0 ? ` (${count} offen)` : ''}`}
    >
      <Mail className="w-[18px] h-[18px] text-gray-600" />
      {count > 0 && (
        <span className="absolute top-1 right-1 min-w-4 h-4 px-1 text-white text-[9px] font-bold rounded-full flex items-center justify-center bg-[#9B1C1C]">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}
